<template>
	<div class="switch">
		<input class="checkbox" type="checkbox" :checked="checked" @change="handleChange" />
	</div>
</template>

<script setup>
import { ref, watchEffect, defineEmits } from 'vue';

const props = defineProps({
	modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue']);

let checked = ref(props.modelValue);

watchEffect(() => {
	checked.value = props.modelValue;
});

const handleChange = event => {
	checked.value = event.target.checked;
	emit('update:modelValue', checked.value);
};
</script>

<style lang="scss" scoped>
.switch {
	margin-right: 0.4rem;
}
.checkbox {
	-webkit-appearance: none;
	appearance: none;
	width: 31px;
	height: 18px;
	background-color: var(--gris-100);
	border: none;
	border-radius: 25px;
	transition: background 0.6s;
	cursor: pointer;
	position: relative;
}
/* Create the toggle */
.checkbox::after {
	content: '';
	width: 0.85rem;
	height: 0.85rem;
	border-radius: 50%;
	background-color: var(--blanc);
	display: block;
	position: absolute;
	top: 50%;
	left: 30%;
	transform: translate(-50%, -50%);
	transition: left 0.3s;
}
/* Change the background when it's checked */
.checkbox:checked {
	background: var(--bleu-200);
}
/* Change position on checked */
.checkbox:checked::after {
	left: 70%;
}
</style>
